import React from 'react';
import "../selfcss/destination.css";

const destinations = [
  { name: "Delhi", image: "assets/img/destinations/delhi.jpg" },
  { name: "Jaipur", image: "assets/img/destinations/jaipur-2.jpg" },
  { name: "Udaipur", image: "assets/img/destinations/udaipur-2.jpg" },
  { name: "Dehradun", image: "assets/img/destinations/dehradun.jpg" },
  // Add more here in the same format
];

function Destination() {
  return (
    <div className="container-xxl py-5 destination" id="destination">
      <div className="container">
        <div className="text-center mb-5">
          <h6 className="section-title bg-white text-primary px-3">
            Destination
          </h6>
          <h1 className="fw-bold">Popular Destinations</h1>
        </div>

        <div className="row g-4">
          {destinations.map((dest, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6 col-12" key={index}>
              <div className="destination-card">
                <img src={dest.image} alt={dest.name} className="img-fluid" />
                <div className="destination-label">{dest.name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Destination;
